<script setup lang="ts">
const { locale } = useI18n()
const { jwt, isSupportConnection, displayBusinessDashboard } = useLocalStorage()

const url = `https://data.heypongo.com?token=${jwt.value}&locale=${locale.value}&isSupportConnection=${isSupportConnection.value}&displayBusinessDashboard=${displayBusinessDashboard.value}`
</script>

<template>
  <div class="h-screen">
    <iframe
      class="h-full w-full"
      :src="url"
      frameborder="0"
      sandbox="allow-scripts allow-same-origin allow-forms allow-top-navigation allow-downloads allow-popups"
      allow="clipboard-write; microphone"
    />
  </div>
</template>
